/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CorePlanningDataDto } from '../../models/core-planning-data-dto';

export interface ProjectAggregatorControllerGetPlanningData$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * Optional filter by project manager ID
 */
  projectManagerId?: string;
}

export function projectAggregatorControllerGetPlanningData(http: HttpClient, rootUrl: string, params: ProjectAggregatorControllerGetPlanningData$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CorePlanningDataDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectAggregatorControllerGetPlanningData.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.query('projectManagerId', params.projectManagerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CorePlanningDataDto>;
    })
  );
}

projectAggregatorControllerGetPlanningData.PATH = '/o2-core/project-aggregator/{tenant}/planning';
